module.exports = __webpack_public_path__ + "static/media/loading_screen@3x.2b08e8b1.jpg";